import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const LOGISTICS_STORE_INCIDENTS = async (url, storeId, month, year) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] +
      url +
      '?storeId=' +
      storeId +
      '&month=' +
      month +
      '&year=' +
      year
  )
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let colorCodes = [];
      let evacuationnumber = [];
      let mic = [];
      let ytdcount = [];
      let NoOfIncidentReports = [];
      let MonthlyInfoData = [];
      let YearlyInfoData = [];
      let MonthlyMandatoryIncidentsData = [];
      let YtdClosureIncidentsData = [];
      let proxyjson = [];

      response.storewiseIncidentReports.map((name, val) => {
        body.push([
          name.monthlyIncidentCount,
          name.monthlyMandatoryIncidentsCount,
          name.monthlyClosedPercentage,
          name.ytdIncidentsCount,
          name.ytdMandatoryIncidentsCount,
          name.ytdClosedPercentage,
        ]);
        stores.push(name.incidentType);
        if (
          name.monthlyClosedPercentage !== '100%' &&
          name.ytdClosedPercentage !== '100%'
        ) {
          colorCodes.push([0, 0, 2, 0, 0, 2]);
        } else if (
          name.monthlyClosedPercentage !== '100%' &&
          name.ytdClosedPercentage == '100%'
        ) {
          colorCodes.push([0, 0, 2, 0, 0, 1]);
        } else if (
          name.monthlyClosedPercentage == '100%' &&
          name.ytdClosedPercentage !== '100%'
        ) {
          colorCodes.push([0, 0, 1, 0, 0, 2]);
        } else {
          colorCodes.push([0, 0, 1, 0, 0, 1]);
        }
        MonthlyInfoData = [];
        YearlyInfoData = [];
        MonthlyMandatoryIncidentsData = [];
        YtdClosureIncidentsData = [];
        name.monthlyInfos.map((info, index) => {
          MonthlyInfoData.push([
            info.incidentType + '-' + info.incidentStoreSerialNo,
            info.alertLevel,
            info.incidentStatus,
            info.incidentDate,
            info.incidentCreatedBy,
          ]);
        });
        name.monthlyMandatoryIncidents.map((info, index) => {
          MonthlyMandatoryIncidentsData.push([
            info.incidentType + '-' + info.incidentStoreSerialNo,
            info.alertLevel,
            info.incidentStatus,
            info.incidentDate,
            info.incidentCreatedBy,
          ]);
        });
        name.yearlyInfos.map((info, index) => {
          YearlyInfoData.push([
            info.incidentType + '-' + info.incidentStoreSerialNo,
            info.alertLevel,
            info.incidentStatus,
            info.incidentDate,
            info.incidentCreatedBy,
          ]);
        });
        name.ytdClosureIncidents.map((info, index) => {
          YtdClosureIncidentsData.push([
            info.incidentType + '-' + info.incidentStoreSerialNo,
            info.alertLevel,
            info.incidentStatus,
            info.incidentDate,
            info.incidentCreatedBy,
          ]);
        });
        mic.push(name.monthlyIncidentCount);
        ytdcount.push(name.ytdIncidentsCount);

        NoOfIncidentReports.push([
          MonthlyInfoData,
          MonthlyMandatoryIncidentsData,
          name.monthlyClosedPercentage,
          YearlyInfoData,
          YtdClosureIncidentsData,
        ]);
      });
      return (proxyjson = {
        type: 'Incidents',

        thead: [
          'Incident Report',
          'No of incidents by month',
          'Incidents with mandatory closure',
          'Closure Status by month',
          'No of Incidents YTD',
          'Closure Status YTD',
          'Closure Percenage YTD',
        ],
        evacuationCount: [0, 0, 0, 0, 0],
        tbody: body,
        columns: [
          'No of incidents by month',
          'Incidents with mandatory closure',
          'Closure Status by month',
          'No of Incidents YTD',
          'Closure Status YTD',
          'Incidents with mandatory closure',
        ],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: NoOfIncidentReports,
        popUpDataGridHeaders: [
          'Incident Type',
          'Alert Level',
          'Status',
          'Date',
          'Created By',
        ],
        ytdCount: ytdcount,
        stores: stores,
        mic: mic,
      });
    });
  return fetchedData;
};
